module.exports = __webpack_public_path__ + "liked-cce48b5e0e3a930284a7.png";